import { LoadingButton } from "@mui/lab";
import { Button, Stack } from "@mui/material";
import { ReactNode, useState } from "react";

import { IModalProps } from "@/types/modals";

export interface ConfirmationModalProps {
    text: ReactNode;
    handleAction?: () => Promise<void> | void;
    autoClose?: boolean;
    actionButtonText?: string;
    cancelButtonText?: string;
    disableCancelButton?: boolean;
    disableSubmitButton?: boolean;
    actionButtonColor?: "primary" | "secondary" | "error" | "success" | "inherit" | "info" | "warning";
}

const ConfirmationModal: React.FC<IModalProps<ConfirmationModalProps>> = ({
    data: {
        text,
        handleAction,
        actionButtonText,
        actionButtonColor,
        cancelButtonText,
        disableSubmitButton = false,
        disableCancelButton = false,
        autoClose = true,
    },
    closeModal,
}) => {
    const [loading, setLoading] = useState<boolean>();

    const handleClick = async () => {
        setLoading(true);
        handleAction && (await handleAction());
        setLoading(false);
        autoClose && closeModal();
    };

    return (
        <>
            <p>{text}</p>
            <Stack direction={"row"} spacing={2}>
                {!disableSubmitButton && (
                    <LoadingButton
                        color={actionButtonColor || "error"}
                        disabled={loading}
                        loading={loading}
                        variant="contained"
                        onClick={handleAction ? handleClick : () => closeModal()}
                    >
                        {actionButtonText || "Yes, I'm Sure"}
                    </LoadingButton>
                )}
                {!disableCancelButton && (
                    <Button color="primary" onClick={() => closeModal()}>
                        {cancelButtonText || "No, Canceled"}
                    </Button>
                )}
            </Stack>
        </>
    );
};

export default ConfirmationModal;
